const handleInput = (e) => {
  let inputValue = '';

  switch (e.target.type) {
    case 'number':
      inputValue = e.target.value === '' ? '' : Number(e.target.value);
      break;

    case 'checkbox':
      inputValue = e.target.checked;
      break;

    default:
      inputValue = e.target.value;
      break;
  }

  return inputValue;
};

export default handleInput;
